import { motion } from "framer-motion";
import CustomLists from "@/components/elements/CustomLists/CustomLists";
import ImageWithContentLeftForProduct from "@/components/elements/ImageWithContent/ImageWithContentLeftForProduct";
import Paragraph from "@/components/elements/Paragraph/Paragraph";
import Table from "@/components/elements/Table/Table";
import TitleBar from "@/components/elements/TitleBar/TitleBar";
import TitleWithContent from "@/components/elements/TitleWithContent/TitleWithContent";
import imgnotavailableImg from '@/assets/images/products/imgnotavailable.png';

const fadeInUp = {
  initial: { opacity: 0, y: 50 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.8, ease: "easeOut" },
  viewport: { once: false, amount: 0.2 },
};

const VistaNoThree = () => {
  return (
    <div className=" 2xl:px-40 xl:px-40 md:px-[3rem] sm:px-5 my-[4rem] ">
      <TitleBar
        title="Vista No. Three"
        subTitle="(Quick Setting Compound for Cement Mortars & Concrete Additives)"
      />

      <motion.div {...fadeInUp}>
        <ImageWithContentLeftForProduct
          imageUrl={imgnotavailableImg}
          title="Description"
          content="Vista No. Three is a multipurpose quick-setting liquid additive for cement mortar and concrete. When added, it accelerates the setting process, resulting in rapid hardening, making it ideal for urgent repairs and construction in wet or time-restricted environments."
        />
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Advantages">
          <CustomLists
            items={[
              [
                "Ideal for use in tunnels, basements, emergency repairs, and stopping water ingress in structures such as swimming pools, water treatment plants, and reservoirs.",
              ],
              [
                "Useful during short shutdowns for emergency repairs.",
                "Effective for sealing leaking joints in concrete and masonry.",
              ],
            ]}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Uses">
          <CustomLists
            items={[
              [
                "User-friendly multipurpose concrete additive.",
                "Helps achieve early shutter removal to accelerate construction schedules.",
                "Highly beneficial in precast industries for fast demolding.",
                "Reliable for urgent factory repairs during shutdowns.",
              ],
              [
                "Seals joints in masonry and cracks in tunnels.",
                "Excellent for concrete work in tidal zones with limited setting time.",
                "Useful for concreting in sub-zero temperatures during winter.",
              ],
            ]}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Properties">
          <Table
            items={{
              headings: [],
              rows: [
                ["Appearance", "Hazy Liquid"],
                ["Specific Gravity", "1.25 ± 0.02"],
                [
                  "Dosage",
                  "3:1 or 4:1 (Vista No. Three : Cement), adjustable as per site conditions",
                ],
                ["Setting Time", "Initial setting time reduced significantly"],
              ],
            }}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Handling Precaution">
          <Paragraph content="Vista No. Three is non-toxic, but ingestion should be avoided. In case of skin contact, rinse thoroughly with clean water. If the product comes in contact with the eyes, wash immediately with plenty of water and seek medical advice." />
        </TitleWithContent>
      </motion.div>
    </div>
  );
};

export default VistaNoThree;
